module.exports = __webpack_public_path__ + "img/ai-avatar.1fabd7f9.png";